'use strict';

angular.module('atex.dam').controller('DamCollectionsController', ['$scope', '$rootScope', 'CollectionService', '$modal', '$q', 'DamActivityService', 'configuration', '$translate',
  function($scope, $rootScope, CollectionService, $modal, $q, DamActivityService, configuration, $translate) {

    $scope.entries = [];
    $scope.loading = false;

    var options = configuration.getCollectionsPanelOptions();

    $scope.reloadCollections = function (fromUi) {
      if ($scope.loading) {
        return;
      }
      $scope.loading = true;
      $scope.entries = [];
      var textToSearch = $('#searchstring').val();
      CollectionService.getAllCollectionsData(textToSearch, options).then(function (collections) {
        if (collections) {
          collections.forEach(function (single) {
            if (single) {
              if (!single.data.aspects.contentData.data.name) {
                single.data.aspects.contentData.data.name =  $translate.getTranslationTable().__NO_NAME__;
              }
              $scope.entries.push(single);
            }
          });
        }
      }).finally(function () {
        $scope.loading = false;
        if (fromUi) {
          $rootScope.$broadcast("dam:openCollectionList");
        }
      });
    };

    $scope.loadCollection = function (id) {
      return CollectionService.getCollection(id).then(function (collection) {
        $rootScope.$broadcast("dam:collectionRetrieved", collection);
      });
    };

    $scope.$on("dam:loadCollection", function (event, contentId) {
      $scope.loadCollection(contentId);
    });

    $scope.reloadCollections();

    $scope.$on("dam:collectionCreated", function (event, collection) {
      $scope.entries.unshift(angular.copy(collection));
    });

    $scope.$on("dam:collectionDeleted", function (event, collection) {
      for (var i = $scope.entries.length - 1; i >= 0; i--) {
        if ($scope.entries[i].id === collection.id) {
          $scope.entries.splice(i, 1);
          break;
        }
      }
    });

    $scope.deleteCollection = function (collectionId) {
      return DamActivityService.lock([collectionId]).then(function () {
        return CollectionService.deleteCollection(collectionId).then(function (collection) {
          DamActivityService.unlock([collectionId]);
          $rootScope.$broadcast("dam:collectionDeleted", collection);
          return collection;
        }).then(null, function () {
          DamActivityService.unlock([collectionId]);
          return $q.reject();
        });
      });
    };

    $scope.$on("dam:logout", function () {
      $scope.entries = [];
    });

    $scope.$on("onecms:authenticationSuccess", function () {
      $scope.reloadCollections();
    });

    $scope.assign = function (collectionId) {
      var assignScope = $rootScope.$new(true);
      assignScope.id = collectionId;
      var modal = $modal({
        show: true,
        scope: assignScope,
        template: 'views/dam-assign.html',
        modalClass: 'dam-modal-assign confirm-modal ng-cloak',
        backdrop: 'static',
        keyboard: false
      });

      var destroyModal = function () {
        modal.then(function (modalEl) {
          modalEl.on('hidden.bs.modal', function () {
            assignScope.$destroy();
            angular.element(this).remove();
          });
          modalEl.modal('hide');
        });
      };

      assignScope.doCancel = function () {
        destroyModal();
      };

      assignScope.doOk = function () {
        destroyModal();
        $rootScope.$broadcast("dam:collectionUpdated", collectionId);
      };
    };

    $scope.searchCollections = function () {
      $scope.reloadCollections(false);
    };

  }
]);

